import React from "react";

const Loader = () => {
  return (
    <div style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      //height: "100vh",  // Full viewport height
    }}> 
      <style>
        {`
          .loader {
            width: 48px;
            height: 48px;
            background: var(--add-color);
            display: inline-block;
            border-radius: 50%;
            box-sizing: border-box;
            animation: animloader 1s ease-in infinite;
          }

          @keyframes animloader {
            0% {
              transform: scale(0);
              opacity: 1;
            }
            100% {
              transform: scale(1);
              opacity: 0;
            }
          }
        `}
      </style>
      <span className="loader"></span>
    </div>
  );
};

export default Loader;
